/* eslint-disable max-len */
import { FC } from 'react';
import cx from 'clsx';

// types
import { IGlyphIcon } from './shared';

// styles
import { useStyles } from './shared/styles';

const MoreVertical: FC<IGlyphIcon> = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M1.07779e-06 2C1.07779e-06 1.60444 0.117299 1.21776 0.337062 0.888861C0.556825 0.559963 0.869182 0.303617 1.23463 0.152242C1.60009 0.000866562 2.00222 -0.0387401 2.39018 0.0384303C2.77814 0.115601 3.13451 0.306082 3.41421 0.585787C3.69392 0.865492 3.8844 1.22186 3.96157 1.60982C4.03874 1.99778 3.99914 2.39992 3.84776 2.76537C3.69639 3.13082 3.44004 3.44318 3.11114 3.66294C2.78224 3.8827 2.39556 4 2 4C1.46957 4 0.960861 3.78929 0.585788 3.41421C0.210715 3.03914 1.07779e-06 2.53043 1.07779e-06 2ZM2 6C1.60444 6 1.21776 6.1173 0.888861 6.33706C0.559963 6.55682 0.303617 6.86918 0.152242 7.23463C0.000866562 7.60009 -0.0387401 8.00222 0.0384303 8.39018C0.115601 8.77814 0.306083 9.13451 0.585788 9.41421C0.865493 9.69392 1.22186 9.8844 1.60982 9.96157C1.99778 10.0387 2.39992 9.99914 2.76537 9.84776C3.13082 9.69639 3.44318 9.44004 3.66294 9.11114C3.8827 8.78224 4 8.39556 4 8C4 7.46957 3.78929 6.96086 3.41421 6.58579C3.03914 6.21071 2.53043 6 2 6ZM2 12C1.60444 12 1.21776 12.1173 0.888861 12.3371C0.559963 12.5568 0.303617 12.8692 0.152242 13.2346C0.000866562 13.6001 -0.0387401 14.0022 0.0384303 14.3902C0.115601 14.7781 0.306083 15.1345 0.585788 15.4142C0.865493 15.6939 1.22186 15.8844 1.60982 15.9616C1.99778 16.0387 2.39992 15.9991 2.76537 15.8478C3.13082 15.6964 3.44318 15.44 3.66294 15.1111C3.8827 14.7822 4 14.3956 4 14C4 13.4696 3.78929 12.9609 3.41421 12.5858C3.03914 12.2107 2.53043 12 2 12Z"
        fill={color}
      />
    </svg>
  );
};

export default MoreVertical;
